(function () {
  var busy = false;

  function parentKey(it) {
    var p = it.properties || {};
    return (p._pz_key && !p._pz_fee) ? p._pz_key : null;
  }

  function sync(callback) {
    if (busy) return;
    busy = true;

    fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var need = {};
        cart.items.forEach(function (it) {
          var k = parentKey(it);
          if (k) need[k] = (need[k] || 0) + it.quantity;
        });

        var updates = {};
        cart.items.forEach(function (it) {
          var p = it.properties || {};
          if (!p._pz_fee) return;
          var want = need[p._pz_key] || 0;
          if (it.quantity !== want) updates[it.key] = want;
        });

        if (!Object.keys(updates).length) {
          busy = false;
          if (typeof callback === 'function') callback();
          return;
        }

        fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ updates: updates })
        })
        .then(function (r) { return r.json(); })
        .then(function () {
          busy = false;
          if (window.theme && window.theme.miniCart) {
            window.theme.miniCart.generateCart();
            window.theme.miniCart.updateElements();
          }
          if (typeof callback === 'function') callback();
        })
        .catch(function () { busy = false; });
      })
      .catch(function () { busy = false; });
  }

  function run() { if (!busy) sync(); }

  if (document.readyState !== 'loading') run();
  else document.addEventListener('DOMContentLoaded', run);

  document.addEventListener('click', function (e) {
    if (e.target.closest('.js-remove-mini-cart')) {
      setTimeout(run, 500);
    }
  }, true);

  document.addEventListener('click', function (e) {
    if (e.target.closest('.js-qty__adjust')) setTimeout(run, 600);
  }, true);

  document.addEventListener('change', function (e) {
    var t = e.target;
    if (t.classList.contains('change-minicart') || t.classList.contains('js-qty__input')) {
      setTimeout(run, 600);
    }
  }, true);

  var _fetch = window.fetch;
  window.fetch = function () {
    var url     = (typeof arguments[0] === 'string') ? arguments[0] : ((arguments[0] && arguments[0].url) || '');
    var mutates = /\/cart\/(add|change|update|clear)(\.js)?(\?|$)/.test(url);
    var isMine  = /\/cart\/update\.js/.test(url) && busy;
    var pr      = _fetch.apply(this, arguments);
    if (mutates && !isMine) {
      pr.then(function () { setTimeout(run, 100); }).catch(function () {});
    }
    return pr;
  };

  document.addEventListener('click', function (e) {
    var t = e.target.closest('.gokwik-checkout button, [onclick*="onCheckoutClick"], [name="checkout"]');
    if (!t || !busy) return;
    e.preventDefault(); e.stopPropagation();
    var tries = 0;
    var wait = setInterval(function () {
      if (!busy || ++tries > 25) { clearInterval(wait); t.click(); }
    }, 60);
  }, true);

})();